import { makeActionCreator } from 'crazyEditor/redux/helpers';

export const ADD_DESKTOP_ELEMENT = 'crazyEditor/element/ADD_DESKTOP_ELEMENT';
export const UPDATE_DESKTOP_ELEMENT = 'crazyEditor/element/UPDATE_DESKTOP_ELEMENT';
export const DELETE_ELEMENT = 'crazyEditor/element/DELETE_ELEMENT';
export const DUPLICATE_DESKTOP_ELEMENT = 'crazyEditor/element/DUPLICATE_DESKTOP_ELEMENT';
export const PASTE_ELEMENTS = 'crazyEditor/element/PASTE_ELEMENTS';

export function addDesktopElement(elementType, elementPosition = null, elementProps = {}) {
  return {type: ADD_DESKTOP_ELEMENT, elementType, elementPosition, elementProps};
}

export function updateDesktopElement(ids, elementProps = {}, templateTag) {
  return {type: UPDATE_DESKTOP_ELEMENT, ids, elementProps, templateTag};
}

export const deleteElement = makeActionCreator(DELETE_ELEMENT, 'ids');
export const duplicateDesktopElement = makeActionCreator(DUPLICATE_DESKTOP_ELEMENT, 'ids');
export const pasteElements = makeActionCreator(PASTE_ELEMENTS, 'elements');

